import { render, staticRenderFns } from "./SugarContentPrediction.vue?vue&type=template&id=9910cfb8&scoped=true&"
import script from "./SugarContentPrediction.vue?vue&type=script&lang=ts&"
export * from "./SugarContentPrediction.vue?vue&type=script&lang=ts&"
import style0 from "./SugarContentPrediction.vue?vue&type=style&index=0&id=9910cfb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9910cfb8",
  null
  
)

export default component.exports